import React from 'react';
import DocxEditor from './components/DocxEditor/DocxEditor';
import './styles/docx-styles.css';

function App() {
    return (
        <div className="App">
            <DocxEditor />
        </div>
    );
}

export default App;